import * as ng from 'angular';
import { ProfileComponent, IProfileController } from './profile';


let ProfileModule = ng.module("app.profile", [
'ngComponentRouter',
//'ngRouteShim',
'ngMaterial',
'ngMessages',
'gettext' // 3rd Party modules

]).component(ProfileComponent.name, ProfileComponent.registration);;

export { IProfileController };
export default ProfileModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/profile/index.ts